
 



 
 import {fs} from "Config/FsConfig";
 
    import NewsData from 'Modules/Aqs/Scripts/AppServiceContract/NewsData';

    import AirQualityIndexGroupData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityIndexGroupData';

    import AirQualityIndexItemData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityIndexItemData';

    import ConfigType from 'Modules/Aqs/Scripts/AppServiceContract/ConfigType';

    import LocationRequest from 'Modules/Aqs/Scripts/AppServiceContract/LocationRequest';

    import AirQualityForecastNCDFData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityForecastNCDFData';

    import AirQualityForecastNCDFValueData from 'Modules/Aqs/Scripts/AppServiceContract/AirQualityForecastNCDFValueData';

    import HeatmapForeCastData from 'Modules/Aqs/Scripts/AppServiceContract/HeatmapForeCastData';


    //module PublicAppService {
    class PublicAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/PublicAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/PublicAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteFindNews = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/FindNews`;
    public RouteFindNews() : string {
        return this.ControllerUrl + "/"+"FindNews";
    }
    public FindNews(): JQuery.jqXHR<NewsData[]> {
        return $.ajax({
                url: this.RouteFindNews(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteFindAirIndex = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/FindAirIndex`;
    public RouteFindAirIndex() : string {
        return this.ControllerUrl + "/"+"FindAirIndex";
    }
    public FindAirIndex(): JQuery.jqXHR<AirQualityIndexGroupData[]> {
        return $.ajax({
                url: this.RouteFindAirIndex(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAirQualityIndexItemPMforMobile = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/AirQualityIndexItemPMforMobile`;
    public RouteAirQualityIndexItemPMforMobile() : string {
        return this.ControllerUrl + "/"+"AirQualityIndexItemPMforMobile";
    }
    public AirQualityIndexItemPMforMobile(): JQuery.jqXHR<AirQualityIndexItemData[]> {
        return $.ajax({
                url: this.RouteAirQualityIndexItemPMforMobile(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAirQualityForecastConfigType = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/AirQualityForecastConfigType`;
    public RouteAirQualityForecastConfigType() : string {
        return this.ControllerUrl + "/"+"AirQualityForecastConfigType";
    }
    public AirQualityForecastConfigType(): JQuery.jqXHR<ConfigType[]> {
        return $.ajax({
                url: this.RouteAirQualityForecastConfigType(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteAirQualityForecastNCDF = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/AirQualityForecastNCDF`;
    public RouteAirQualityForecastNCDF() : string {
        return this.ControllerUrl + "/"+"AirQualityForecastNCDF";
    }
    public AirQualityForecastNCDF(locationRequest: LocationRequest): JQuery.jqXHR<AirQualityForecastNCDFData[]> {
        return $.ajax({
                url: this.RouteAirQualityForecastNCDF(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(locationRequest),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/${encodeURIComponent(id)}
    //public static RouteAirQualityRealvalueGraph = (id: string) => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/AirQualityRealvalueGraph`;
    public RouteAirQualityRealvalueGraph(id: string) : string {
        return this.ControllerUrl + "/"+"AirQualityRealvalueGraph";
    }
    public AirQualityRealvalueGraph(id: string): JQuery.jqXHR<AirQualityForecastNCDFValueData[]> {
        return $.ajax({
                url: this.RouteAirQualityRealvalueGraph(id),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(id),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
    // post: api/${controller}/
    //public static RouteHeatmapForecastNCDF = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicAppService/HeatmapForecastNCDF`;
    public RouteHeatmapForecastNCDF() : string {
        return this.ControllerUrl + "/"+"HeatmapForecastNCDF";
    }
    public HeatmapForecastNCDF(): JQuery.jqXHR<HeatmapForeCastData[]> {
        return $.ajax({
                url: this.RouteHeatmapForecastNCDF(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: null,
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default PublicAppService;



